// extracted by mini-css-extract-plugin
export default {"container":"EditProfileScreen_container__cCw9o","actions":"EditProfileScreen_actions__1jt8-","form":"EditProfileScreen_form__52+K5"};